setUpdatePaymentOrderComplete